<template>
  <nav class="navbar navbar-expand-lg navbar-dark fixed-top">
    <div class="container">
      <a class="navbar-brand" href="#" @click="navigateToHome">
        <img src="@/assets/images/logo.png" alt="39游戏盒子" height="40">
      </a>

      <!-- 移动端按钮组：下载按钮在左，切换按钮在右 -->
      <div class="mobile-nav-controls d-flex align-items-center">
        <div class="download-btn-img" @click="handleDownload">
        </div>
        <button class="navbar-toggler custom-toggler" type="button" @click="toggleMobileMenu" :class="{ 'collapsed': !isMenuOpen }" :aria-expanded="isMenuOpen">
          <img src="@/assets/images/zss.png" alt="菜单" class="toggler-icon-open">
          <span class="toggler-icon-close">×</span>
        </button>
      </div>

      <!-- 移动端弹出菜单 -->
      <div class="mobile-menu navbar-collapse" :class="{ 'show': isMenuOpen }">
        <div class="container">
          <ul class="navbar-nav">
            <li class="nav-item">
              <a class="nav-link" :class="{ 'active': currentSection === 'home' }" href="#" @click="navigateToSection('home')">
                首页
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#" @click="navigateToSection('web')">
                网页版
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" :class="{ 'active': currentSection === 'changelog' }" href="#" @click="navigateToSection('changelog')">
                更新日志
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- PC端下载按钮 -->
      <a class="download-btn-img d-none d-lg-block ms-auto" href="https://bbsnewapi.3975bbs.com/common/packageAppLink?advertisingId=350" target="_blank">
      </a>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'NavBar',
  props: {
    currentSection: {
      type: String,
      default: 'home'
    }
  },
  data() {
    return {
      isMenuOpen: false
    }
  },
  methods: {
    toggleMobileMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    navigateToHome() {
      this.navigateToSection('home');
    },
    navigateToSection(section) {
      this.isMenuOpen = false; // 关闭移动端菜单
      if(section === 'web'){
        window.open('https://front.3975bbs.com?advertisingId=433');
        return
      }
      this.$emit('navigate', section);
    },
    handleDownload() {
      window.open('https://bbsnewapi.3975bbs.com/common/packageAppLink?advertisingId=353');
    }
  }
}
</script>

<style scoped>

</style>